import React from 'react';
import { Navigate } from 'react-router';

export function withShopSettingsRedirect() {
  return (useHasAccess, redirectPath = '/') =>
    (DecoratedComponent) =>
      (props) => {
        const hasAccess = useHasAccess();

        if (hasAccess) {
          return <DecoratedComponent {...props} />;
        }

        return <Navigate to={redirectPath} />;
      };
}

export default withShopSettingsRedirect();
